// Statistiques d'un client à partir de son arbre de groupes
// (GET /customers/:id/groups — top-level avec children imbriqués).
// « Utilisateurs » = somme des member_count des Réseaux : le nombre de
// rattachements au client (GET /customers/:id/members) ne compte que les
// gestionnaires, pas les utilisateurs des Réseaux.

export type CustomerGroupTreeNode = {
  type?: string;
  member_count?: number;
  children?: CustomerGroupTreeNode[] | null;
};

const countDescendants = (group: CustomerGroupTreeNode): number =>
  (group.children ?? []).reduce(
    (acc, child) => acc + 1 + countDescendants(child),
    0
  );

export const computeCustomerTreeStats = (
  topLevelGroups: CustomerGroupTreeNode[]
): { networks: number; communities: number; users: number } => {
  const networks = topLevelGroups.filter(group => group.type !== 'wellbeing');

  return {
    networks: networks.length,
    communities: networks.reduce(
      (acc, group) => acc + countDescendants(group),
      0
    ),
    users: networks.reduce((acc, group) => acc + (group.member_count ?? 0), 0),
  };
};
